var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mobile-responsive-shell',{attrs:{"title":_vm.title}},[_c('desktop-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }